define(function (require) {
    return {
        sendGoogleAnalytics: function (params) {
            params = params || {};

            const isFile = params.isFile || false;
            const isAuthorized = params.isAuthorized || false;

            if (isFile) {
                RADAR.ga('send', 'event', {
                    eventCategory: 'public-file-view-old',
                    eventAction: 'social-click',
                    eventLabel: isAuthorized ? 'user' : 'anon',
                });
            }
        },
        send: function (params) {
            params = params || {};

            var item = params.item || {};
            var socialIconsId = params.service + '';
            var storage = params.storage + '';
            var platform = params.platform + '';
            var socialIconsView = params.socialIconsView + ''; // toolbar | content | publishing;
            var sendKaktam = params.sendKaktam || false;
            var isShoved = params.isShoved || false;
            var isFile = params.isFile || false;

            var pageType;
            if (socialIconsView === 'publishing') {
                pageType = isFile ? 'file' : 'folder';
            } else {
                pageType = 'public-' + (isFile ? 'file' : 'folder') + '_' + (isShoved ? 'shoved' : 'not-shoved');
            }

            var kaktamObject;
            var filename = item.name + '';
            var kind = item.kind + '';
            var subKind = item.subKind + '';
            var ext = item.ext + '';
            var url = (item.url && item.url.get) + '';
            var hash = item.hash + '';
            var radar = RADAR.group('social-icons_' + socialIconsView + '_' + socialIconsId + '_' + pageType + '_' + platform);

            radar.add(isFile ? 'file' : 'folder');
            isFile && radar.add(ext);
            radar.add('all');

            if (sendKaktam) {
                kaktamObject = {
                    url: url,
                    kind: kind,
                    subKind: subKind,
                    location: window.location.href,
                    storage: storage,
                    service: socialIconsId,
                    filename: filename,
                    platform: platform,
                    pageType: pageType,
                    hash: hash,
                };
                if (isFile) {
                    kaktamObject.ext = ext;
                }
                radar.kaktam('social-icons', JSON.stringify(kaktamObject));
            }

            radar.send();
        },
    };
});
